import React from "react";

const fieldError = ({ children }) => (
  <div style={{ color: "red", padding: "5px" }}>{children}</div>
);

export default fieldError;
